import React, { Component } from 'react';

import ImageLogo from './static/img/logo-white.png';

class TopBar extends Component {
    constructor(props) {
        super(props);
        this.state = {}
    }

    handleOnBack() {
        if(this.props.onBack) {
            this.props.onBack();
        }
    }

    handleOnClose() {
        if(this.props.onClose) {
            this.props.onClose();
        }
    }

    renderTitle() {
        if(this.props.title) {
            return (
                <div className="hw-widget__top-bar__title">
                    {/* <div className="hw-widget__separator"></div> */}
                    <h2>{this.props.title}</h2>
                </div>
            )
        }
    }
    
    render() { 
        return (
            <React.Fragment>
                <div className="hw-widget__top-bar">
                    <div className={this.props.anchor ? "hw-widget__top-bar__anchor" : "hw-widget__top-bar__button"} onClick={() => this.handleOnBack()}>
                        Go Back
                    </div>
                    <img src={ImageLogo} alt="" />
                    <p className="hw-widget__close-button hw-widget__close-button--no-anchor" onClick={() => this.handleOnClose()}></p>
                </div>
                {this.renderTitle()}
            </React.Fragment>
        );
    }
}
 
export default TopBar;